import React from 'react';
import './scroll.css';

function Scroll() {
  return (
    <div className="aniWrap">
      <div className="mouse">
        <div className="scroller" />
      </div>
    </div>
  );
}

export default Scroll;
